import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #F0F0F0',
    borderRadius: '7px',
    boxSizing: 'border-box',
    boxShadow:
      '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
    width: 500,
    height: 300,
    padding: 12,
    background: 'white',
    [theme.breakpoints.down('sm')]: {
      width: 300
    }
  },

  comments: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto'
  },

  input: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '4px',

    '& .text': {
      width: '100%',
      maxWidth: '100%'
    }
  },
  closeBtn: {
    marginRight: -7,
    alignSelf: 'flex-end',
    cursor: 'pointer',
    paddingBottom: '0.25rem'
  }
}))

export default useStyles
